<template>
    <div class="menu-container">
        <div class="menu-list-box">
            <ul class="menu-list">
                <li class="menu-item-parent" v-for="(item_i, i) in menuList" :key="i" :class="{itembgactive:item_i.isActive || 
                    item_i.menuOpen}">
                    <div class="parent-name" @click="checkMenu(i, -1, -1)" :class="{pnactive:item_i.isActive}">
                        <i class="icon iconfont icon-shezhi"></i>
                        <span>{{item_i.name}}</span>
                        <i class="icon iconfont icon-arrow-right open-arrow" v-if="item_i.haveChild" 
                            :class="{arrowclose:item_i.menuOpen}"></i>
                    </div>
                    <ul class="menu-item-child-box" v-if="item_i.haveChild" :class="{menuopen:item_i.menuOpen}">
                        <li class="menu-item-children" v-for="(item_j, j) in item_i.children" :key="j">
                            <div class="child-name" :class="{cnactive:item_j.isActive}" 
                                @click.stop="checkMenu(i, j, -1)">
                                <span>{{item_j.name}}</span>
                                <i class="icon iconfont icon-arrow-right open-arrow" v-if="item_j.haveChild" 
                                    :class="{arrowclose:item_j.menuOpen}"></i>
                            </div>
                            <ul class="menu-item-grandson-box" v-if="item_j.haveChild" :class="{menuopen:item_j.menuOpen}">
                                <li class="menu-item-grandson" v-for="(item_k, k) in item_j.children" :key="k">
                                    <div class="grandson-name" :class="{gnactive:item_k.isActive}"
                                        @click.stop="checkMenu(i, j, k)">
                                        <span>{{item_k.name}}</span>
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MenuComponent',
    data() {
        return {
            // 左侧菜单栏列表
            menuList: [],
            // 已存在的菜单选中项
            oldMenuActives: {
                pnActive: -1,
                cnActive: -1,
                gnActive: -1
            },
            // 已存在的菜单展开项(仅针对一级菜单)
            oldMenuOpened: -1
        }
    },
    created() {
        this.getMenuList();
        this.listenMenuStatus();
    },
    mounted() {
        
    },
    methods: {
        /**
         * @function getMenuList 获取菜单列表数据
         */
        getMenuList() {
            // this.$axios.get(this.urls.menuList).then(res => {
            //     console.log(res);
            // });
            this.$axios.get('static/json/menu.json').then(res => {
                this.menuList = res.data.menuList;
                this.getSessionData();
            });
        },
        /**
         * @function listenMenuStatus 监听取消菜单栏选中状态
         */
        listenMenuStatus() {
            this.Bus.$on('clearMenuActive', res => {
                if(res) {
                    let [i, j, k] = [this.oldMenuActives.pnActive, this.oldMenuActives.cnActive, this.oldMenuActives.gnActive];
                    if(i > -1) {
                        this.menuList[i].isActive = false;
                        if(j > -1) {
                            this.menuList[i].children[j].isActive = false;
                            if(k > -1) {
                                this.menuList[i].children[j].children[k].isActive = false;
                            }
                        }
                    }
                    if(this.oldMenuOpened > -1) {
                        this.menuList[this.oldMenuOpened].menuOpen = false;
                    }
                    this.oldMenuActives.pnActive = -1;
                    this.oldMenuActives.cnActive = -1;
                    this.oldMenuActives.gnActive = -1;
                    this.oldMenuOpened = -1;
                }
            });
        },
        /**
         * @function getSessionData 获取本地缓存的页面信息
         */
        getSessionData() {
            let data = window.sessionStorage.getItem('menuChecked');
            if(data) {
                let _data = JSON.parse(data), item = {};
                let [i, j, k] = [Number(_data.parentIdx), Number(_data.childIdx), Number(_data.grandsonIdx)];
                let open = Number(_data.openedIdx);
                if(open > -1) {
                    this.menuList[i].menuOpen = true;
                }
                if(i > -1) {
                    this.menuList[i].isActive = true;
                    item = {
                        name: this.menuList[i].name,
                        path: this.menuList[i].path
                    };
                    if(j > -1) {
                        this.menuList[i].children[j].isActive = true;
                        this.oldMenuOpened = i;
                        item = {
                            name: this.menuList[i].children[j].name,
                            path: this.menuList[i].children[j].path,
                            parent_name: this.menuList[i].name
                        };
                        if(k > -1) {
                            this.menuList[i].children[j].children[k].isActive = true;
                            item = {
                                name: this.menuList[i].children[j].children[k].name,
                                path: this.menuList[i].children[j].children[k].path,
                                parent_name: this.menuList[i].name,
                                child_name: this.menuList[i].children[j].name
                            };
                        }
                    }
                }
                this.oldMenuActives.pnActive = i;
                this.oldMenuActives.cnActive = j;
                this.oldMenuActives.gnActive = k;
                this.oldMenuOpened = open;
                // this.setPathNavData(item, false);
                this.setSessionData();
            }
        },
        /**
         * @function checkMenu 点击菜单方法
         * @param { number } i 一级菜单下标
         * @param { number } j 二级菜单下标
         * @param { number } k 三级菜单下标
         */
        checkMenu(i, j, k) {
            if(k > -1) {
                this.checkMenuThree(i, j, k);
            } else {
                if(j > -1) {
                    this.checkMenuTwo(i, j);
                } else {
                    this.checkMenuOne(i);
                }
            }
        },
        /**
         * @function checkMenuOne 点击一级菜单方法
         * @param { number } i 一级菜单下标
         */
        checkMenuOne(i) {
            let oldParentIdx = this.oldMenuActives.pnActive;
            if(oldParentIdx > -1) {
                // 一级菜单有选中项
                if(oldParentIdx === i) {
                    if(this.menuList[i].haveChild) {
                        if(this.oldMenuOpened > -1) {
                            if(this.oldMenuOpened === i) {
                                this.menuList[i].menuOpen = false;
                                this.oldMenuOpened = -1;
                            } else {
                                this.menuList[this.oldMenuOpened].menuOpen = false;
                                this.menuList[i].menuOpen = true;
                                this.oldMenuOpened = i;
                            }
                        } else {
                            this.menuList[i].menuOpen = true;
                            this.oldMenuOpened = i;
                        }
                    }
                } else {
                    if(this.menuList[i].haveChild) {
                        if(this.oldMenuOpened > -1) {
                            if(this.oldMenuOpened === i) {
                                this.menuList[i].menuOpen = false;
                                this.oldMenuOpened = -1;
                            } else {
                                this.menuList[this.oldMenuOpened].menuOpen = false;
                                this.menuList[i].menuOpen = true;
                                this.oldMenuOpened = i;
                            }
                        } else {
                            this.menuList[i].menuOpen = true;
                            this.oldMenuOpened = i;
                        }
                    } else {
                        if(this.oldMenuOpened > -1) {
                            this.menuList[this.oldMenuOpened].menuOpen = false;
                            this.oldMenuOpened = -1;
                        }
                        this.menuList[oldParentIdx].isActive = false;
                        let oldChildIdx = this.oldMenuActives.cnActive;
                        if(oldChildIdx > -1) {
                            this.menuList[oldParentIdx].children[oldChildIdx].isActive = false;
                            let oldGrandsonIdx = this.oldMenuActives.gnActive;
                            if(oldGrandsonIdx > -1) {
                                this.menuList[oldParentIdx].children[oldChildIdx].children[oldGrandsonIdx].isActive = false;
                                this.oldMenuActives.gnActive = -1;
                            }
                            this.oldMenuActives.cnActive = -1;
                        }
                        this.oldMenuActives.pnActive = -1;
                        this.menuList[i].isActive = true;
                        this.oldMenuActives.pnActive = i;
                        // 页面跳转
                        let item = {
                            name: this.menuList[i].name,
                            path: this.menuList[i].path
                        };
                        this.setPathNavData(item, false);
                        this.toPage(item.path, this.menuList[i].id);
                    }
                }
            } else {
                // 一级菜单没有选中项
                if(this.oldMenuOpened > -1) {
                    // 存在已展开的菜单
                    if(this.oldMenuOpened === i) {
                        // 已展开的菜单为当前点击的菜单，收起
                        this.menuList[i].menuOpen = false;
                        this.oldMenuOpened = -1;
                    } else {
                        // 当前点击的菜单项不是已展开的菜单项
                        this.menuList[this.oldMenuOpened].menuOpen = false;
                        this.oldMenuOpened = -1;
                        if(this.menuList[i].haveChild) {
                            this.menuList[i].menuOpen = true;
                            this.oldMenuOpened = i;
                        } else {
                            this.menuList[i].isActive = true;
                            this.oldMenuActives.pnActive = i;
                            // 页面跳转
                            let item = {
                                name: this.menuList[i].name,
                                path: this.menuList[i].path
                            };
                            this.setPathNavData(item, false);
                            this.toPage(item.path, this.menuList[i].id);
                        }
                    }
                } else {
                    // 不存在已展开的菜单
                    if(this.menuList[i].haveChild) {
                        this.menuList[i].menuOpen = true;
                        this.oldMenuOpened = i;
                    } else {
                        this.menuList[i].isActive = true;
                        this.oldMenuActives.pnActive = i;
                        // 页面跳转
                        let item = {
                            name: this.menuList[i].name,
                            path: this.menuList[i].path
                        };
                        this.setPathNavData(item, false);
                        this.toPage(item.path, this.menuList[i].id);
                    }
                }
            }
        },
        /**
         * @function checkMenuTwo 点击二级菜单方法
         * @param { number } i 一级菜单下标
         * @param { number } j 二级菜单下标
         */
        checkMenuTwo(i, j) {
            if(this.menuList[i].children[j].haveChild) {
                this.menuList[i].children[j].menuOpen = !this.menuList[i].children[j].menuOpen;
            } else {
                let oldParentIdx = this.oldMenuActives.pnActive;
                if(oldParentIdx > -1) {
                    this.menuList[oldParentIdx].isActive = false;
                    let oldChildIdx = this.oldMenuActives.cnActive;
                    if(oldChildIdx > -1) {
                        this.menuList[oldParentIdx].children[oldChildIdx].isActive = false;
                        let oldGrandsonIdx = this.oldMenuActives.gnActive;
                        if(oldGrandsonIdx > -1) {
                            this.menuList[oldParentIdx].children[oldChildIdx].children[oldGrandsonIdx].isActive = false;
                            this.oldMenuActives.gnActive = -1;
                        }
                        this.oldMenuActives.cnActive = -1;
                    }
                    this.oldMenuActives.pnActive = -1;
                }
                this.menuList[i].isActive = true;
                this.menuList[i].children[j].isActive = true;
                this.oldMenuActives.pnActive = i;
                this.oldMenuActives.cnActive = j;
                // 跳转页面
                let item = {
                    name: this.menuList[i].children[j].name,
                    path: this.menuList[i].children[j].path,
                    parent_name: this.menuList[i].name
                };
                this.setPathNavData(item, false);
                this.toPage(item.path, this.menuList[i].children[j].id);
            }
        },
        /**
         * @function checkMenuTwo 点击三级菜单方法
         * @param { number } i 一级菜单下标
         * @param { number } j 二级菜单下标
         * @param { number } k 三级菜单下标
         */
        checkMenuThree(i, j, k) {
            let oldParentIdx = this.oldMenuActives.pnActive;
            if(oldParentIdx > -1) {
                this.menuList[oldParentIdx].isActive = false;
                let oldChildIdx = this.oldMenuActives.cnActive;
                if(oldChildIdx > -1) {
                    this.menuList[oldParentIdx].children[oldChildIdx].isActive = false;
                    let oldGrandsonIdx = this.oldMenuActives.gnActive;
                    if(oldGrandsonIdx > -1) {
                        this.menuList[oldParentIdx].children[oldChildIdx].children[oldGrandsonIdx].isActive = false;
                        this.oldMenuActives.gnActive = -1;
                    }
                    this.oldMenuActives.cnActive = -1;
                }
                this.oldMenuActives.pnActive = -1;
            }
            this.menuList[i].isActive = true;
            this.menuList[i].children[j].isActive = true;
            this.menuList[i].children[j].children[k].isActive = true;
            this.oldMenuActives.pnActive = i;
            this.oldMenuActives.cnActive = j;
            this.oldMenuActives.gnActive = k;
            // 跳转页面
            let item = {
                name: this.menuList[i].children[j].children[k].name,
                path: this.menuList[i].children[j].children[k].path,
                parent_name: this.menuList[i].name,
                child_name: this.menuList[i].children[j].name
            };
            this.setPathNavData(item, false);
            this.toPage(item.path, this.menuList[i].children[j].children[k].id);
        },
        /**
         * @function setPathNavData 设置路径导航方法
         * @param { object } data 路径导航数据
         * @param { boolea } flag 替换或推入, true推入, false替换
         */
        setPathNavData(data, flag) {
            let item = {
                data: data,
                flag: flag,
            };
            this.$store.commit('setNavData', item);
            this.setSessionData();
            // this.toPage(data.path);
        },
        /**
         * @function setSessionData 保存页面信息到本地
         */
        setSessionData() {
            let data = {
                parentIdx: this.oldMenuActives.pnActive,
                childIdx: this.oldMenuActives.cnActive,
                grandsonIdx: this.oldMenuActives.gnActive,
                openedIdx: this.oldMenuOpened
            }
            window.sessionStorage.setItem('menuChecked', JSON.stringify(data));
        },
        /**
         * @function toPage 跳转页面方法
         * @param { string } path 页面路径
         */
        toPage(path, id) {
            console.log(path, id);
            // let pageParams = {}, tableParams = {};
            // if(id >= 10 && id <= 15) {
            //     switch (id) {
            //         case 10: // 抓取设置
            //             pageParams = {
            //                 page_name: 'captureSet',
            //                 page_title_navs: [],
            //                 table_filtrates: {
            //                     column: true,
            //                     search: true
            //                 }
            //             };
            //             tableParams = {
            //                 table_api: this.urls.grabColumnList,
            //                 table_api_params: {}
            //             };
            //             break;
            //         case 11: // 抓取发布
            //             pageParams = {
            //                 page_name: 'captureIssue',
            //                 page_title_navs: [],
            //                 table_filtrates: {
            //                     captureColumn: true,
            //                     issueColumn: true,
            //                     search: true
            //                 }
            //             };
            //             tableParams = {
            //                 table_api: this.urls.grabColumnList,
            //                 table_api_params: {}
            //             };
            //             break;
            //         case 12: // 原创审核
            //             pageParams = {
            //                 page_name: 'originalAudit',
            //                 page_title_navs: [],
            //                 table_filtrates: {
            //                     issueColumn: true,
            //                     search: true
            //                 }
            //             };
            //             tableParams = {
            //                 table_api: this.urls.articleList,
            //                 table_api_params: {}
            //             };
            //             break;
            //         case 13: // 原创设置
            //             pageParams = {
            //                 page_name: 'originalSet',
            //                 page_title_navs: [],
            //                 table_filtrates: {
            //                     issueColumn: true,
            //                     search: true
            //                 }
            //             };
            //             tableParams = {
            //                 table_api: this.urls.articleList,
            //                 table_api_params: {}
            //             };
            //             break;
            //         case 14: // 发布管理
            //             pageParams = {
            //                 page_name: 'mpWeiXinArticle',
            //                 page_title_navs: [],
            //                 table_filtrates: {
            //                     column: true,
            //                     search: true
            //                 }
            //             };
            //             tableParams = {
            //                 table_api: this.urls.grabColumnList,
            //                 table_api_params: {}
            //             };
            //             break;
            //         case 15: // 公众号文章
            //             pageParams = {
            //                 page_name: 'issueManage',
            //                 page_title_navs: [],
            //                 table_filtrates: {
            //                     column: true,
            //                     search: true
            //                 }
            //             };
            //             tableParams = {
            //                 table_api: this.urls.grabColumnList,
            //                 table_api_params: {}
            //             };
            //             break;
            //         default:
            //             break;
            //     }
            //     let obj = {
            //         limit: 10,
            //         page: 1
            //     };
            //     Object.assign(tableParams.table_api_params, obj);
            //     this.$store.commit('setTablePageParams', { flag: true, pageParams: pageParams });
            //     this.$store.dispatch('getTableData', tableParams);
            //     this.$router.push({path: '/tablePage'});
            // } else {
            //     this.$router.push({ path: path });
            // }
            this.$router.push({ path: path });
        }
    }
}
</script>
<style lang="scss" scoped>
@import './MenuComponent.scss';
</style>
<style lang="scss">
@media screen and (min-width: 500px) {
    ul.el-menu-vertical-demo.el-menu {
        padding: 10px 0;
        li.el-menu-item, .el-submenu__title {
            height: 42px;
            padding: 0 16px 0 25px !important;
            line-height: 42px;
            &:hover {
                > i, span {
                    color: #fff !important;
                }
            }
            > i {
                font-size: 14px !important;
            }
        }
        .el-submenu__title {
            height: 42px;
            padding: 0 16px 0 25px !important;
            line-height: 42px;
            &:hover {
                > i, span {
                    color: #fff !important;
                }
            }
            > i {
                font-size: 14px !important;
            }
        }
        li.el-submenu.is-opened {
            .el-submenu__title, li.el-menu-item {
                background: $a_cdbgc_y !important;
            }
            .el-submenu__title {
                > i {
                    font-size: 14px !important;
                }
            }
            li.el-menu-item {
                padding: 0 16px 0 55px !important;
            }
        }
        li.el-submenu {
            i.el-submenu__icon-arrow.el-icon-arrow-down {
                font-size: 16px;
            }
        }
        ul.el-menu.el-menu--inline {
            > li.el-menu-item {
                padding: 0 16px 0 55px !important;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/menu/MenuComponent.vue